// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var NotificationTypeIcon = require("./NotificationTypeIcon");

var make = NotificationTypeIcon.NotificationTypeIconContainer;

exports.make = make;
/* make Not a pure module */
